import React, { useEffect, useState } from "react";
import UseTranslationHook from "../../hooks/UseTranslationHook";
import Loader from "../../core-component/ui/Loader";
import { fetchFirmId, IFirmForm } from "./FirmFormController";
import { IFirm } from "./FirmListController";
import { FormRightModalWrapper } from "../../core-component/ui";
import { ICSwitch } from "../../core-component/form";
import MaskedValue from "../../core-component/ui/ICMaskedValue";

interface IFirmFormProps {
  handleClose: (status: boolean) => void;
  firmToView: IFirm;
}

const FirmForm: React.FC<IFirmFormProps> = ({ handleClose, firmToView }) => {
  const { t } = UseTranslationHook();
  const [loading, setLoading] = useState(false);
  const [firmFormInitialValues, setFirmFormInitialValues] =
    useState<IFirmForm>();

  useEffect(() => {
    getFirmById(firmToView.id);
  }, []);

  const getFirmById = async (id: string) => {
    setLoading(true);
    await fetchFirmId(id, handleClose, setFirmFormInitialValues);
    setLoading(false);
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          {firmFormInitialValues && (
            <FormRightModalWrapper
              containerClassName="!w-1/3"
              onClose={() => handleClose(false)}
              title={t("firm")}
              footer={{
                created_date: firmFormInitialValues.created_date,
                modified_date: firmFormInitialValues.modified_date,
                created_by: firmFormInitialValues.created_by,
                modified_by: firmFormInitialValues.modified_by,
              }}
            >
              <div className="p-4 bg-base rounded-md">
                <div className="border-b pb-1">
                  <div className="text-sm text-muted">{t("firm_name")}</div>
                  <div>{firmFormInitialValues.firm_name}</div>
                </div>
                <div className="mt-4 border-b pb-1">
                  <div className="text-sm text-muted">
                    {t("contact_person_name")}
                  </div>
                  <div>{firmFormInitialValues.contact_person_name}</div>
                </div>
                <div className="mt-4 border-b pb-1">
                  <div className="text-sm text-muted">
                    {t("contact_person_mobile")}
                  </div>
                  <div>
                    <MaskedValue
                      value={firmFormInitialValues.contact_person_mobile}
                      regex={/(\d{5})$/}
                    />
                  </div>
                </div>
                <div className="mt-4 border-b pb-1">
                  <div className="text-sm text-muted">
                    {t("contact_person_email")}
                  </div>
                  <div>
                    <MaskedValue
                      value={firmFormInitialValues.contact_person_email}
                      regex={/(?<=.).(?=[^@]*?@)|(?:@)([^@]{2})(?=.*\.)/gm}
                    />
                  </div>
                </div>
                <div className="mt-4 border-b pb-1">
                  <div className="text-sm text-muted">{t("firm_type")}</div>
                  <div>{firmFormInitialValues.firm_type}</div>
                </div>
                <div className="mt-4 border-b pb-2">
                  <div className="text-sm text-muted">{t("status")}</div>
                  <ICSwitch
                    containerClassName="!cursor-default mt-1"
                    checked
                    onChange={() => {}}
                    disabled
                  />
                </div>
                {firmFormInitialValues.address && (
                  <div className="mt-4 border-b pb-1">
                    <div className="text-sm text-muted">{t("address")}</div>
                    <div>
                      {firmFormInitialValues.address.address_line1},&nbsp;
                      {firmFormInitialValues.address.address_line2},&nbsp;
                      {firmFormInitialValues.address?.address_line3 &&
                        firmFormInitialValues.address?.address_line3 + ","}
                    </div>
                    <div>
                      {firmFormInitialValues.address.city},&nbsp;
                      {firmFormInitialValues.address.zip_code},&nbsp;
                      {firmFormInitialValues.address.state_name},&nbsp;
                      {firmFormInitialValues.address.country_name}
                    </div>
                  </div>
                )}
              </div>
            </FormRightModalWrapper>
          )}
        </>
      )}
    </>
  );
};

export default FirmForm;
